import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/notifications";

export default function NotificationsPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="notifications"
        title="Meldingen"
        subtitle="Blijf op de hoogte van alles wat er gebeurt via push-meldingen en in-app notificaties."
        color="#8B5CF6"
      />

      {/* Soorten meldingen */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Soorten Meldingen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De app stuurt meldingen voor verschillende gebeurtenissen. Zo mis je nooit iets belangrijks!
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="flash"
          title="Nieuwe uitdaging"
          description="Wanneer de commissie een nieuwe uitdaging beschikbaar maakt, ontvang je een melding zodat je direct kunt meedoen."
          color="#10B981"
        />
        <GuideCard
          icon="trophy"
          title="Uitdaging beoordeeld"
          description="Na het beoordelen van je inzending ontvang je een melding: goedgekeurd (met punten!) of afgekeurd (met feedback)."
          color="#F59E0B"
        />
        <GuideCard
          icon="chatbubble"
          title="Chatbericht"
          description="Ontvang meldingen voor nieuwe berichten in chats. Je kunt dit per chat in- of uitschakelen."
          color="#6366F1"
        />
        <GuideCard
          icon="megaphone"
          title="Aankondiging"
          description="Belangrijke aankondigingen van de commissie, zoals programmawijzigingen of updates over het weekend."
          color="#8B5CF6"
        />
        <GuideCard
          icon="calendar"
          title="Evenement herinnering"
          description="Een herinnering voor een aankomend evenement uit de agenda. Standaard 15-30 minuten van tevoren."
          color="#10B981"
        />
        <GuideCard
          icon="star"
          title="Score update"
          description="Wanneer je team punten verdient of de teamstand verandert."
          color="#F59E0B"
        />
        <GuideCard
          icon="people"
          title="Team update"
          description="Wijzigingen in je team, zoals nieuwe leden of veranderingen in de teamsamenstelling."
          color="#EC4899"
        />
      </View>

      {/* Push vs In-app */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Push vs In-app Meldingen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Er zijn twee soorten meldingen:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="phone-portrait"
          title="Push-meldingen"
          description="Verschijnen op je telefoon, ook als de app niet open is. Je ziet ze in je notificatiebalk. Tik erop om direct naar het relevante scherm te gaan."
          color="#3B82F6"
        />
        <GuideCard
          icon="notifications"
          title="In-app meldingen"
          description="Zichtbaar in het meldingenoverzicht binnen de app. Hier vind je een compleet overzicht van alle meldingen met tijdstip en details."
          color="#8B5CF6"
        />
      </View>

      <GuideTip title="Meldingenscherm">
        Open het meldingenscherm via het bel-icoontje op het startscherm. Meldingen zijn 
        gegroepeerd op datum (vandaag, gisteren, deze week, ouder). Swipe een melding 
        om deze als gelezen te markeren.
      </GuideTip>

      {/* Instellingen */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Instellingen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Je kunt zelf instellen welke meldingen je wilt ontvangen:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="settings"
          title="Meldingsvoorkeuren"
          description="Ga naar Profiel > Meldingen om per type aan te geven of je push-meldingen wilt ontvangen. Je kunt bijvoorbeeld chatmeldingen uitschakelen maar uitdagingsmeldingen aan laten."
          color="#6B7280"
        />
        <GuideCard
          icon="volume-mute"
          title="Chat dempen"
          description="In elke chat kun je meldingen dempen. Handig als een groep erg actief is en je even rust wilt."
          color="#EF4444"
        />
      </View>

      <GuideTip variant="warning" icon="alert-circle" title="Toestemming vereist">
        Om push-meldingen te ontvangen, moet je de app toestemming geven. Als je bij de 
        eerste keer "nee" hebt gekozen, kun je dit wijzigen in de instellingen van je telefoon 
        onder de Staatsen App.
      </GuideTip>

      {/* Animaties */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Feestelijke Meldingen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Sommige meldingen worden vergezeld door een feestelijke animatie! Wanneer je een 
        uitdaging voltooit, punten verdient of een bijzonder moment bereikt, kan er een 
        vrolijke Lottie-animatie verschijnen met confetti of een trofee.
      </Text>

      <GuideNav {...nav} />
    </View>
  );
}
